const canonicalDocumentCursor = ({ document, cursorOffset }) => {
  if (typeof document !== 'string') {
    throw new TypeError('document must be a string')
  }
  if (!Number.isSafeInteger(cursorOffset) ||
      cursorOffset < 0 ||
      cursorOffset > document.length) {
    throw new RangeError('cursorOffset must be a valid UTF-16 offset')
  }
  return { document, cursorOffset }
}

const keyboardContext = lang => ({
  localeIdentifier: typeof lang === 'string' && lang.trim() ? lang : 'und',
  keyboardType: 'default'
})

export const autocompletePayload = ({
  document,
  cursorOffset,
  lang,
  mode,
  selectionStart,
  selectionEnd,
  strategy = 'semanticFirstWord',
  temperature = 0.1
}) => {
  const payload = {
    ...canonicalDocumentCursor({ document, cursorOffset }),
    context: keyboardContext(lang),
    strategy,
    temperature
  }
  if (mode !== 'selection') return payload
  if (!Number.isSafeInteger(selectionStart) ||
      !Number.isSafeInteger(selectionEnd) ||
      selectionStart < 0 ||
      selectionEnd <= selectionStart ||
      selectionEnd > document.length) {
    throw new RangeError('selection must be a valid nonempty UTF-16 range')
  }
  return {
    ...payload,
    mode,
    selectionStart,
    selectionEnd
  }
}

export const autocorrectPayload = ({
  document,
  cursorOffset,
  lang,
  timestamp,
  mode,
  autocorrectApplyThreshold,
  autocorrectLevel
}) => ({
  ...canonicalDocumentCursor({ document, cursorOffset }),
  context: keyboardContext(lang),
  timestamp,
  mode,
  autocorrectApplyThreshold,
  ...(autocorrectLevel === undefined ? {} : { autocorrectLevel })
})
